import React from 'react'
import './WalletCardStepper.scss'
import { STEP_KEYS } from '../../../../../Utils/Constant/WalletCard'

interface StepProps {
  index: number
  label: string
  isActive: boolean
  isCompleted: boolean
  onClick?: (step: number) => void
  isTemplate: boolean
}

interface StepperProps {
  steps: {key?: string; label: string}[]
  activeSteps: Record<string, boolean>
  completedSteps: Record<string, boolean>
  onStepClick?: (step: number) => void
  isTemplate: boolean
}

const Step: React.FC<StepProps> = ({index, label, isActive, isCompleted, onClick, isTemplate = false}) => {
  const shouldHideStep = !isTemplate && index >= 2
  return (
    <div className={`step-item w-100 ${shouldHideStep ? 'd-none' : ''}`}>
      <div
        className={`stepper-circle rounded-circle d-flex justify-content-center align-items-center  text-black ${
          isCompleted
            ? 'stepper-circle-completed'
            : isActive
            ? 'stepper-circle-active'
            : 'stepper-circle-inactive'
        } ${onClick ? 'stepper-circle-clickable' : 'stepper-circle-non-clickable'}`}
        onClick={() => onClick && onClick(index)}
      >
        {isCompleted ? '' : index + 1}
      </div>
      <div className={`step-label ${isActive || isCompleted ? 'stepper-active' : ''} w-auto`}>
        {label}
      </div>
    </div>
  )
}

const Stepper: React.FC<StepperProps> = ({steps, activeSteps, completedSteps, onStepClick, isTemplate = false}) => {
  const getDefaultKeyForIndex = (index: number): string => {
    switch (index) {
      case 0:
        return STEP_KEYS.GETTING_STARTED
      case 1:
        return STEP_KEYS.CARD_DETAILS
      case 2:
        return STEP_KEYS.SHARE_CONTACT_DETAILS
      default:
        return `step${index}`
    }
  }

  const getActiveStepIndex = (): number => {
    const activeStepKeys = Object.keys(activeSteps)
    const activeStepIndex = activeStepKeys.findIndex((key) => activeSteps[key])
    return activeStepIndex === -1 ? 0 : activeStepIndex
  }

  const getCompletedPercentage = (): number => {
    const activeIndex = getActiveStepIndex()
    const width = isTemplate ? 70 : 140
    return (activeIndex / (steps.length - 1)) * width
  }

  const activeStepIndex = getActiveStepIndex()

  return (
    <div className='stepper-container stepper-container-card w-100'>
      {/* Connecting lines */}
      <div className={`stepper-line ${isTemplate ? '' : 'stepper-line-card'}`} />

      {/* Active line */}
      <div
        className={`stepper-line-active ${isTemplate ? '' : 'stepper-line-active-card'}`}
        style={{
          width: `${getCompletedPercentage()}%`,
        }}
      />

      {/* Steps */}
      {steps.map((step, index) => {
        const stepKey = step.key || getDefaultKeyForIndex(index)
        const isCompleted = !!completedSteps[stepKey]
        const isActive = index === activeStepIndex
        
        return (
          <Step
            key={index}
            index={index}
            label={step.label}
            isActive={isActive}
            isCompleted={isCompleted}
            onClick={onStepClick}
            isTemplate={isTemplate}
          />
        )
      })}
    </div>
  )
}

export default Stepper
